import zhLocale from 'element-ui/lib/locale/lang/en'

export default {

  "lang": "中文",

// 主页
  "Home": {
    "metaInfo": {
      "title1": {"title": "使用AI将图片转变成多风格卡通"},
      "title2": {"keywords": "一款能够将您喜爱的照片转化为日漫、3D或自由手绘风格漫画图片的AI工具"},
      "title3": {"description": "该工具允许您将喜爱的照片转换为漫画图像，具有漫画、3D或自由风格的样式，提供多样化的艺术变换。它为用户提供了在其喜爱的图片中注入不同视觉美学的能力，从富有动感和风格化的漫画外观到3D的深度或自由绘画的魅力。"},
    },
    "img": {
      "img1": {"content": "图片原图"},
      "img2": {"content": "3D风格效果图"},
      "img3": {"content": "自由手绘风格效果图"},
      "img4": {"content": "艺术效果效果图"},
    },
    "body1": {
      "text1": {"text": "街头照、肖像、团体照... "},
      "text2": {"text": "随意上传您喜爱的照片,"},
      "text3": {"text": " 选择相应的风格（漫画、3D、自由手绘），"},
      "text4": {"text": " 只需点击一下，即可将照片转换为不同风格的卡通图片！"},
      "text5": {"text": "多风格人像模型已建立,"},
      "text6": {"text": "您可以通过鼠标点击立即在朋友圈占据关键位置,"},
      "text7": {"text": "立即尽情展示。"},
      "style": {"style": "风格选择"},
      "radio": {
        "label1": "漫画风格",
        "label2": "3D风格",
        "label3": "自由手绘风格",
        "label4": "素描风格",
        "label5": "艺术效果",
      },
      "btn": {"btn": "快速生成"},
      "format": {"format": "上传头像仅支持JPG、PNG、webp格式！"},
      "picture-size": {"picture-size": "上传头像大小不得超过5MB！"},
    },
    "body2": {
      "title": {"title": "他们喜欢我们，你也会喜欢"},
      "content1": {"content": "AICartoonGenerator改进了Bosch Cognitiveservices客户备件更换"},
      "content2": {"content": "AICartoonGenerator帮助Nordstrom将每张图像的成本降低60%"},
      "content3": {"content": "AICartoonGenerator使Spoak的客户更容易可视化新的室内设计"},
      "content4": {"content": "AICartoonGenerator通过替代笨重的绿屏，将物理空间需求减少98%"},
      "content5": {"content": "AICartoonGenerator为KemmetmuellerPhotography节省了12.5周的处理时间"},
      "content6": {"content": "AICartoonGenerator为KemmetmuellerPhotography节省了12.5周的处理时间"},
    },
    "body3": {
      "title": {"title": "特点"},
      "text": {"text": "通过我们创新的方法，将图像转换为卡通变得轻松。我们采用高质量的图像生成技术，确保清晰而一流的图像，利用先进的人工智能算法提供精准而智能的体验，并提供灵活的定价选项，为您量身定制成本效益的体验。您从照片到卡通的旅程从未如此高效和贴合您的需求。"},
      "card1": {
        "title": {"title": "高质量图像生成"},
        "content": {"content": "通过高质量的图像生成技术提升您的视觉内容，确保为所有创意需求提供清晰和一流的图像。"},
      },
      "card2": {
        "title": {"title": "先进的人工智能算法"},
        "content": {"content": "运用先进的人工智能算法，发挥创新的力量。在您的流程中实现无与伦比的精度、效率和智能。"},
      },
      "card3": {
        "title": {"title": "图像保存"},
        "content": {"content": "轻松保存您的视觉内容。安全、方便，确保您的图像随时可访问。"},
      },
      "card4": {
        "title": {"title": "灵活的定价"},
        "content": {"content": "通过灵活的定价体验财务上的适应性。根据您的特定需求定制投资，确保在各个层面都能实现成本效益和价值。"},
      },
    },
  },

// 博客
  "blog": {
    "title": {"title": "最新博客文章"},
    "text": {
      "text": "通过我们创新的方法，将图像转换为卡通变得轻松。我们采用高质量的图像生成技术，确保清晰而一流的图像，利用先进的人工智能算法提供精准而智能的体验，并提供灵活的定价选项，为您量身定制成本效益的体验。您从照片到卡通的旅程从未如此高效和贴合您的需求。"
    },
    "card1": {
      "title": {"title": "为生活增添活力，借助卡通艺术"},
      "content": {"content": "创建头像的首选AI工具！将自己轻松变成卡通形象，获得愉悦和100%自动化的体验。"},
      "detail": {
        "title": {"title": "用卡通艺术赋予生活活力"},
        "box1": {
          "title": {"title": "如何编辑照片？"},
          "text": {"text": "只需3个简单步骤，就可以将图像变成多风格卡通，创造出像专业摄影师一样美丽的图像。"},
        },
        "box2": {
          "title": {"title": "上传图片"},
          "text": {"text": "将图片上传或拖放到 " + " 框中开始编辑。"},
        },
        "box3": {
          "title": {"title": "选择样式以更改图像"},
          "text": {"text": "选择由人工智能自动检测的对象，以将其更改为不同的卡通风格图像。"},
        },

        "box4": {
          "title": {"title": "下载和分享"},
          "text": {"text": "在编辑应用程序后，下载您编辑过的漂亮图片或直接分享到您的社交媒体。"},
        },

        "card1": {
          "title": {"title": "商品"},
          "content": {"content": "受体育启发的卡通人物可以出现在各种商品上，包括T恤、帽子和其他服装。这些物品可以销售给球迷，并在体育赛事期间作为宣传材料。例如，巴克兔(Bugs Bunny)的形象已被纳入NBA夏洛特黄蜂队的商品中，展示了动画人物和体育品牌之间潜在的交叉点。"},
        },
        "card2": {
          "title": {"title": "教育材料"},
          "content": {"content": "利用体育卡通人物提供了一种引人入胜的方式，向儿童传授体育精神和健康生活方式的原则。像史酷比杜和他的朋友们这样的角色可以充当大使，推动体育活动，并向年轻观众传授有关团队合作和公平竞技的宝贵经验。"},
        },
        "card3": {
          "title": {"title": "视频游戏"},
          "content": {"content": "在视频游戏中利用体育卡通人物可以吸引年轻的受众。将备受喜爱的形象，如海绵宝宝或刺猬索尼克，融入以体育为主题的视频游戏，有望提高它们在儿童中的吸引力。这种做法不仅向年轻人介绍不同的体育项目，还通过互动和有趣的游戏体验激发他们对体育活动的兴趣。"},
        },
        "card4": {
          "title": {"title": "吉祥物"},
          "content": {"content": "体育卡通人物是体育团队的理想吉祥物。一个团队的吉祥物在代表其身份和促进与球迷之间的深厚联系方面起着至关重要的作用。以费城费城人队为例，Philly Phanatic是与费城费城人棒球队相关联的备受喜爱的吉祥物。这个吉祥物不仅为球队形象增添了有趣和活泼的元素，而且与球迷建立了难忘的联系。"},
        },
      }
    },

    "card2": {
      "title": {"title": "通过卡通化自己来庆祝节日季节"},
      "content": {"content": "通过卡通角色为您的节日快照注入一丝喜悦。在AICartoonGenerator免费提供的最佳在线AI卡通人脸制作者中探索，为您的节日期间的照片增添童趣魅力。"},
      "detail": {
        "title": {"title": "通过卡通化自己来庆祝节日季节"},
        "text": {"text": "通过卡通角色为您的节日快照注入一丝喜悦。在AICartoonGenerator免费提供的最佳在线AI卡通人脸制作者中探索，为您的节日期间的照片增添童趣魅力。"},
        "box1": {
          "title": {"title": "如何编辑照片？"},
          "text": {"text": "只需3个简单步骤，将图像更改为多样化卡通，创建像专业摄影师一样美丽的图像。"},
        },
        "box2": {
          "title": {"title": "上传图片"},
          "text": {"text": "上传或拖放图像到“+”框中开始编辑。"},
        },
        "box3": {
          "title": {"title": "选择要更改的图像风格"},
          "text": {"text": "选择AI自动检测到的对象，以更改为不同的卡通风格图像。"},
        },
        "box4": {
          "title": {"title": "下载和分享"},
          "text": {"text": "编辑申请后，下载您编辑过的美丽图像或直接分享到社交媒体。"},
        },
        "card1": {
          "title": {"title": "电子卡片"},
          "content": {"content": "通过我们的网站为您的亲人定制问候卡。通过加入个性化的卡通角色，为您的电子卡片增添独特的风采，带来额外的特别感触。"},
        },
        "card2": {
          "title": {"title": "装饰"},
          "content": {"content": "通过加入个性化的卡通角色，提升您的节日装饰。制作欢快而有趣的角色，为您的节日装饰注入独特的魅力。"},
        },
        "card3": {
          "title": {"title": "礼物"},
          "content": {"content": "通过为您的亲人制作定制卡通角色，为您的节日礼物增添个人和创意的色彩。调整这些角色以匹配他们独特的个性，创造出一份真正特别而体贴的礼物。"},
        },
        "card4": {
          "title": {"title": "派对邀请"},
          "content": {"content": "通过加入个性化的卡通角色，提升您的节日派对邀请的吸引力。制作生动而欢快的角色，为即将到来的节日庆祝活动营造出完美的氛围。"},
        },
      }
    },

    "card3": {
      "title": {"title": "通过卡通形象彰显职业形象"},
      "content": {"content": "AICartoonGenerator是一款突出的AI工具，用于打造个性化的卡通形象。将您的自拍瞬间轻松变成引人入胜的卡通形象。这种创新的方法不仅增强了您的职业形象，还给人留下持久而令人难忘的印象！"},
      "detail": {
        "title": {"title": "通过卡通形象彰显职业形象"},
        "text": {"text": "AICartoonGenerator是一款突出的AI工具，用于打造个性化的卡通形象。将您的自拍瞬间轻松变成引人入胜的卡通形象。这种创新的方法不仅增强了您的职业形象，还给人留下持久而令人难忘的印象！"},
        "box1": {
          "title": {"title": "如何编辑照片？"},
          "text": {"text": "只需3个简单的步骤，即可将图像更改为多样式卡通，并创建美丽的图像，就像专业摄影师一样。"},
        },
        "box2": {
          "title": {"title": "上传图片"},
          "text": {"text": "将图片上传或拖放到“+”框中，开始编辑。"},
        },
        "box3": {
          "title": {"title": "选择要更改图像的样式"},
          "text": {"text": "选择由AI自动检测到的对象，以更改为不同的卡通风格图像。"},
        },
        "box4": {
          "title": {"title": "下载和分享"},
          "text": {"text": "编辑完成后，下载您编辑过的漂亮图像，或直接分享到社交媒体。"},
        },
        "card1": {
          "title": {"title": "员工培训与发展"},
          "content": {"content": "利用职业卡通形象是培养新员工的引人注目和有影响力培训视频和材料的高效策略。这些形象作为视觉辅助工具，描绘了常见的工作场景，从处理具有挑战性的客户到促进团队成员之间的合作，以及掌握高效的时间管理。将职业卡通形象融入培训计划中可以提高员工的参与度和互动性，从而提高信息的保留和员工对信息的实际应用。"},
        },
        "card2": {
          "title": {"title": "职业指导与咨询"},
          "content": {"content": "职业卡通形象是向正在开始职业生涯的学生和年轻专业人士提供指导和咨询的有价值资产。这些形象提供有关选择适当职业道路、成功职业旅程导航以及克服职场挑战的见解。教育工作者和职业顾问可以通过将职业卡通形象整合到职业指导材料中，提高内容对年轻观众的吸引力，促进更多的参与。"},
        },
        "card3": {
          "title": {"title": "招聘与雇主品牌塑造"},
          "content": {"content": "利用职业卡通形象可以有效提升公司的雇主品牌，并吸引顶级人才的关注。将这些形象整合到招聘广告和公司网站上，作为组织文化、价值观以及职业发展潜力的视觉代表。将职业卡通形象融入招聘和雇主品牌塑造活动中，使公司能够在竞争激烈的环境中脱颖而出，吸引多元化的求职者群体。"},
        },
        "card4": {
          "title": {"title": "营销和广告"},
          "content": {"content": "将职业卡通形象整合到面向专业人士的营销和广告活动中是一种有效的策略。这些形象在视觉上传达了特定产品或服务的优势，展示了公司的产品如何有助于专业人士在职业生涯中取得成功。通过将职业卡通形象纳入营销活动，公司可以提升其内容的吸引力，使其更具参与度和记忆度。这反过来增加了品牌认知度并促进客户忠诚度。"},
        },
      }
    },
    "card4": {
      "title": {"title": "通过卡通形象实现体育伟大"},
      "content": {"content": "AICartoonGenerator是一款利用最新AI卡通技术的创新在线工具。这是个轻松而有创意的方式，个性化您的运动员头像。"},
      "detail": {
        "title": {"title": "通过卡通形象实现体育伟大"},
        "text": {"text": "AICartoonGenerator是一款利用最新AI卡通技术的创新在线工具。这是个轻松而有创意的方式，个性化您的运动员头像。"},
        "box1": {
          "title": {"title": "如何编辑照片？"},
          "text": {"text": "只需3个简单的步骤，即可将图像更改为多样式卡通，并创建美丽的图像，就像专业摄影师一样。"},
        },
        "box2": {
          "title": {"title": "上传图片"},
          "text": {"text": "将图片上传或拖放到“+”框中，开始编辑。"},
        },
        "box3": {
          "title": {"title": "选择要更改图像的样式"},
          "text": {"text": "选择由AI自动检测到的对象，以更改为不同的卡通风格图像。"},
        },
        "box4": {
          "title": {"title": "下载和分享"},
          "text": {"text": "编辑完成后，下载您编辑过的漂亮图像，或直接分享到社交媒体。"},
        },

        "card1": {
          "title": {"title": "商品"},
          "content": {"content": "受体育启发的卡通形象可以展示在各种商品上，包括T恤、帽子和其他服饰。这些物品可以销售给球迷，并在体育赛事期间用作促销材料。例如，Bugs Bunny的角色已经被纳入NBA夏洛特黄蜂队的商品中，展示了动画角色与体育品牌之间的潜在交叉点。"},
        },
        "card2": {
          "title": {"title": "教育材料"},
          "content": {"content": "在教育儿童体育道德和健康生活方式原则方面，利用体育卡通形象提供一种引人入胜的方式。像Scooby-Doo和他的朋友这样的角色可以作为大使，推动体育活动，并向年轻观众传授有关团队合作和公平竞争的宝贵教训。"},
        },
        "card3": {
          "title": {"title": "视频游戏"},
          "content": {"content": "在视频游戏中利用体育卡通形象可以吸引年轻的受众。将受欢迎的角色，如SpongeBob SquarePants或Sonic the Hedgehog，融入以体育为主题的视频游戏中，有望提高这些游戏在儿童中的吸引力。这种方法不仅向年轻人介绍了不同的体育项目，还通过互动和娱乐性的游戏体验激发了他们对体育活动的兴趣。"},
        },
        "card4": {
          "title": {"title": "吉祥物"},
          "content": {"content": "体育卡通形象是作为体育团队吉祥物的理想人选。团队吉祥物在代表其身份并促进团队与球迷之间建立深厚联系方面起着至关重要的作用。例如，Philly Phanatic就是费城费城人棒球队喜爱的吉祥物，为球队形象增添了有趣和充满活力的元素，同时与球迷建立了难忘的联系。"},
        },
      }
    },
  },

// 联系我们
  "ContactUs": {
    "title": {"title": "联系我们"},
    "text": {"text": "填写此表格，我们将尽快与您联系。"},
    "input": {
      "label1": "姓名",
      "label2": "电子邮件地址",
      "label3": "主题",
      "label4": "消息",
    },
    "btn": {"btn": "发送"}
  },

//Privacy Policy
  "PrivacyPolicy": {
    "title": {"title": "隐私政策"},
    "body": {
      "title": {
        "title1": "什么是AICartoonGenerator？",
        "title2": "它来自哪里？",
        "title3": "为什么我们使用它？",
        "title4": "我在哪里可以得到一些？",
      },
      "text": {
        "text1": "AICartoonGenerator",
        "text2": "是印刷和排版行业的虚拟文字。自从16世纪以来，AICartoonGenerator一直是该行业的标准虚拟文字，当时一位未知的印刷工人拿起了一篇活字印刷的文章，将其打乱以制作排印样品。它不仅存活了五个世纪，而且还跃入了电子排版，基本保持不变。它在20世纪60年代因Letraset公司发布的包含AICartoonGenerator段落的排印样张而变得流行，近年来又随着Aldus PageMaker等桌面排版软件的推出而变得更加普及。",
        "text3": "与流行观念相反，AICartoonGenerator并不是简单的随机文本。它源自公元前45年西塞罗的《善恶的极端》（The Extremes of Good and Evil）中的一段古典拉丁文学作品，有着超过2000年的历史。弗吉尼亚州汉普顿-悉尼学院的拉丁文教授理查德·麦克林托克（Richard McClintock）查找了“AICartoonGenerator”段落中的一个较为晦涩的拉丁词语“consectetur”，并通过对该词在古典文学中的引用进行研究，发现了其不容置疑的来源。AICartoonGenerator源自公元前45年西塞罗的《善恶的极端》第1.10.32和1.10.33节。这本书是文艺复兴时期非常流行的一部伦理学理论著作。AICartoonGenerator的第一行，“AICartoonGenerator dolor sit amet..”，来自于第1.10.32节的一行。",
        "text4": "自1500年以来一直使用的AICartoonGenerator标准块如下，对于感兴趣的人，也会重现《善恶的极端》中第1.10.32和1.10.33节，H·拉克姆（H. Rackham）在1914年的翻译版本中的英文版本也将被重现。",
        "text5": "众所周知，当一个页面的可读内容在其布局时会分散读者的注意力。使用Lorem Ipsum的要点在于它具有与“Content here, content here”不同的字母分布，使其看起来像是可读的英语。许多桌面排版软件和网页编辑器现在使用Lorem Ipsum作为它们的默认模型文本，搜索“Lorem Ipsum”将发现许多仍处于初期阶段的网站。多年来有很多版本的Lorem Ipsum，有时是出于偶然，有时是出于故意（注入的幽默等）。",
        "text6": "有许多Lorem Ipsum段落的变体，但大多数都经历了某种形式的改动，无论是注入了幽默，还是随机化的词语，这些都不太可信。如果您要使用一段Lorem Ipsum，您需要确保文本中没有隐藏的尴尬内容。互联网上的所有Lorem Ipsum生成器都倾向于根据需要重复预定义的块，这使得它成为互联网上的第一个真正的生成器。它使用超过200个拉丁单词的字典，结合少数模型句子结构，生成看起来合理的Lorem Ipsum。生成的Lorem Ipsum因此始终不受重复、注入的幽默或非特征性单词等影响。",
      }
    }
  },
  //Terms of use
  "TermsOfUse": {
    "title": {"title": "使用条款"},
    "body": {
      "title": {
        "title1": "1. 前言",
        "title2": "2. 使用权",
        "title3": "3. 用户的权利和义务",
        "title4": "4. 担保和责任",
        "title5": "5. 保密性和数据保护",
        "title6": "6. 结束条款",
        "title7": "7. 订阅取消和帐户删除",
        "title8": "8. API公平使用政策",
      },
      "text": {
        "text1": "1.1. MiniCom（以下简称运营商）运营 ai-cartoon-figure.club 网站，这是一个用于编辑照片的基于Web的应用程序。本使用条款适用于 ai-cartoon-figure.club 平台（以下简称：用户）的所有用户。",
        "text2": "2.1. 通过同意，用户同意运营商可以存储用户的IP地址以验证对平台的广泛使用。",
        "text3": "2.2. 您的内容",
        "text4": "2.2.1. 内容。 “内容” 指的是您上传、导入、嵌入以供服务和软件使用或使用服务和软件创建的任何文本、信息、通信或材料，如音频文件、视频文件、电子文档或图像。如果发现您的任何内容违反条款，我们保留删除内容或限制访问内容、服务和软件的权利（但无义务）。我们不会审查上传到服务和软件的所有内容，但我们可能使用可用的技术、供应商或流程来筛选特定类型的非法内容（例如，儿童色情）或其他滥用内容或行为（例如，表明垃圾邮件、网络钓鱼或包含成人内容的关键词已被发布在成人区以外的活动模式）。",
        "text5": "2.2.2. 对您的内容的许可。仅为运营或改进服务和软件的目的，您授予我们一项非独占性、全球范围、免费许可、可转让的许可，以使用、复制、公开展示、分发、修改、基于您的内容创建衍生作品、公开执行并翻译内容。例如，我们可能将对内容的权利转让给我们的服务提供商或其他用户，以使服务和软件能够按预期运行，如允许您与他人分享照片。另外，下面的第4.5节（反馈）涵盖您向我们提供的任何反馈。",
        "text6": "2.2.3. 所有权。在您和 ai-cartoon-figure.club 之间，您（作为企业用户或个人用户，视情况而定）保留对您的内容的所有权利。我们不主张对您的内容的任何所有权。",
        "text7": "2.2.4. 分享您的内容。",
        "text8": "(A) 分享。某些服务和软件可能提供功能，允许您与其他用户分享您的内容或使其公开。 “分享”是指通过使用服务和软件发送电子邮件、张贴、传输、流式传输、上传或以其他方式提供（无论是向我们还是其他用户）的行为。其他用户可能以多种方式使用、复制、修改或重新共享您的内容。在选择分享或公开的内容时，请仔细考虑，因为您对您分享的内容负责。",
        "text9": "(B) 访问级别。我们不监控或控制其他人对您的内容的操作。您负责确定对您的内容设置的限制，并为您的内容应用适当的访问级别。如果您未选择要应用于您的内容的访问级别，则系统可能默认为其最宽松的访问级别。您的内容可能会被共享，并且您有责任确定对您的内容施加的限制，并调整与访问或共享您的内容相关的设置。",
        "text10": "(C) 评论。您通过服务和软件提交的任何评论都不是匿名的，可能会被其他用户查看。在某些服务和软件中，您的评论可能会被您、其他用户或我们删除。",
        "text11": "(D) 删除您的内容。如果您从服务和软件中删除内容（不包括反馈），我们将在合理的时间内停止公开提供该内容。您的内容的某些副本可能会被保留作为例行备份的一部分，我们对于您分享或公开的内容的任何使用概不负责。",
        "text12": "3.1. 用户承诺不采取任何危害软件功能或运行的行动。特别是，用户禁止执行扫描或测试软件的弱点、绕过安全系统或访问软件系统或将恶意软件集成到软件中的任何行动。",
        "text13": "3.2. 用户保证拥有处理上传的照片的一切必要权利（如著作权、附属著作权、工业产权、商标权）。",
        "text14": "4.1. 对软件结果及其可用性的任何担保均被排除。然而，如果存在担保要求，担保期为六个月。",
        "text15": "4.2. 运营商对软件的速度、可用性、数据丢失或结果的正确性不负责。此外，除非损害是故意或重大过失造成的，否则运营商的责任被排除。在人的生命或身体损害的情况下，不适用此规定。",
        "text16": "4.3. 运营商的责任在任何情况下均限于100.00欧元。",
        "text17": "4.4. 终止：AICartoonGenerator 保留随时暂停和/或终止本协议的权利，无需通知和无需承担责任，无论出于何种原因（例如，如果您违反本协议）还是出于便利（例如，如果AICartoonGenerator正在终止服务）。我们保留修改、暂时暂停或永久删除您的帐户并终止您访问服务的权利，如果我们有理由相信您违反或行为不一致 与条款。终止后，您的许可将自动被撤销，我们保留删除您的帐户、删除您个人资料上的所有或任何信息并丢弃您的用户内容的权利。您同意我们对于服务的任何修改或终止不对您负责。我们对从您的个人资料中删除信息或内容不承担任何责任。您承认并接受在终止您的帐户后，某些用户内容可能仍然存在，用户内容许可将不会被撤销或终止。如果在我们终止您的帐户时您的订阅仍然有效，您将不会收到剩余订阅时间的退款。",
        "text18": "4.5. AICartoonGenerator Pro 订阅：AICartoonGenerator Pro 目前不支持跨多个平台使用，这意味着您在 ai-cartoon-figure.club 网站上的专业访问不适用于 AICartoonGenerator iOS 和 Android 应用程序的专业访问。",
        "text19": "5.1. 所有数据保护信息均可在 www.ai-cartoon-figure.club/policy 上供用户查阅。",
        "text20": "6.1. 本合同引起的法律纠纷仅适用奥地利法。排除适用《联合国国际货物销售公约》、IPRG的引用标准以及欧洲议会和理事会于2008年6月17日颁布的关于合同债务适用法律的规定（罗马I条例）。",
        "text21": "6.2. 就因本合同引起或与之有关的争议，专属管辖权属于奥地利维也纳市中心的有管辖权的法院。",
        "text22": "6.3. 对本合同的任何更改和/或补充必须以书面形式进行，方为有效；对于违反此形式要求的情况，也需要书面形式。",
        "text23": "6.4. 如果本合同的某些条款无效、不可执行和/或无效，不得因此导致整个合同的无效、不可执行和/或无效。在这种情况下，合同双方同意就无效、不可执行和/或无效的条款达成经济上尽可能接近该条款所追求目的的协议，以替代无效、不可执行和/或无效的条款。",
        "text24": "6.5. 如果运营商以德语以外的语言呈现这些服务条款，则翻译是由经过ISO 17100:2015认证的独立专业翻译员准备的，并由至少另一名专业翻译员校对。如果在争议的情况下，法院坚持要求德语合同文本，那么只有原始的德语合同文本有效；绝不使用对翻译版本的再翻译。",
        "text25": "7.1 取消订阅 您可以随时取消对付费服务的订阅，您将继续在计费周期结束前访问付费服务。在适用法律允许的范围内，付款不可退还，我们不提供未使用的付费服务的退款。为了取消订阅，您可以转到'My Account'，并按照其中的说明进行操作。",
        "text26": "7.2 账户删除 您还可以通过联系我们的方式(handsometong2016@gmail.com)删除您的账户。在关闭您的账户并按照您的具体指示进行数据清除时，我们将尽一切合理努力清除与您的账户相关的所有数据。我们保留根据适用法律保留任何必要数据的权利。在取消订阅或关闭您的账户后，您可以继续使用在取消或关闭日期之前通过服务创建、生成或复制的任何作品，前提是此类使用必须符合这些使用条款、许可协议以及我们不时制定的任何其他相关许可协议。",
        "text27": "此API可接受使用政策规定了您在任何情况下使用、联系或与我们的API进行交互时适用的条款。",
        "text28": "8.1 接受条款",
        "text29": "通过使用我们的API，您接受这些条款 通过使用我们的API，您确认您接受本政策的条款，并同意遵守这些条款。",
        "text30": "如果您不同意这些条款，您不得使用我们的API。我们建议您打印这些条款以备将来参考。",
        "text31": "还有其他可能适用于您的条款 还有其他条款，包括许可条款，可能适用于您对我们的软件和API的使用，包括可能在与我们签订的任何其他协议中规定的条款。",
        "text32": "我们可能会更改本政策的条款 我们会不定期修改这些条款，恕不另行通知。每次您希望使用我们的API时，请检查这些条款，以确保您了解适用于当时的条款。这些条款的最近更新日期在这些条款前面声明的日期上。",
        "text33": "8.2. 合理使用",
        "text34": "为了所有API用户的利益，用户必须遵守对API的合理和公正使用，以防止停机、数据的丢失、损坏或损害以及其他错误或技术问题。",
        "text35": "API的使用必须限制在合理数量的并发调用（API请求）上，同时在启动进一步调用之前等待适当的完成时间。我们可能会不时规定特定的调用限制，您将需要遵守这些限制。",
        "text36": "如果您从使用我们的API中收到错误报告或错误代码，您必须立即通知我们，并适当减少您对API的使用。",
        "text37": "密钥：API可能需要密钥才能运行或访问。您负责安装和使用密钥，并且不得复制或与第三方分享密钥。",
        "text38": "8.3. 滥用的后果",
        "text39": "除了我们可能拥有的任何其他权利之外，在您未能遵守上述公平使用或未能遵守本API政策条款的其他情况下：",
        "text40": "您将对我们或我们集团的任何成员因您的违约而直接或间接遭受或发生的所有费用、损失、责任、损害、索赔和费用负责并对我们进行赔偿，包括但不限于与数据损坏、破坏或损坏相关的前述所有费用、损失、责任、损害、索赔和费用；以及",
        "text42": "我们可能会监视您对API的使用，包括验证是否符合本政策。",
        "text41": "我们有权（无需通知）暂停、修改、限制或以其他方式限制您对API的使用。",
        "text43": "您应允许我们和/或我们的代表在您使用API方面执行此类审核和/或验证，并根据我们合理要求检查和访问您的场所和/或系统或信息。",
        "text44": "8.4. 禁止使用",
        "text45": "您只能以合法的目的使用我们的API。您不得以以下任何方式使用我们的API：",
        "text46": "违反任何适用的地方法律、国家法律或国际法规的方式。",
        "text47": "以非法或欺诈的方式使用，或具有任何非法或欺诈目的或效果的方式。",
        "text48": "传输或促使发送任何未经请求或未经授权的广告或促销材料或任何其他类似招揽（垃圾邮件）的方式。",
        "text49": "故意传输任何包含病毒、木马、蠕虫、定时炸弹、键盘记录器、间谍软件、广告软件或任何其他有害程序或类似计算机代码的数据，发送或上传任何数据，以对计算机软件或硬件的正常运行产生不利影响。",
        "text50": "您还同意：",
        "text51": "不复制、复制、复制或重新出售我们API的任何部分；除法律允许的范围外，不得反编译、反向工程、拆解或以其他方式推导API任何部分的源代码；",
        "text52": "未经授权不得访问、干扰、损坏或中断：我们API的任何部分；我们API存储的任何设备或网络；或我们API提供中所使用的任何软件。",
        "text53": "8.5. API提供",
        "text54": "我们保留（无需对您或任何其他人承担责任）修改、修改、更改或以任何方式处理API的权利，并且我们不保证API将继续可用。",
        "text55": "我们可能随时在不通知您或任何其他人的情况下中止或暂停API的提供，并由我们自行决定，无需对您或任何其他人承担责任。",
        "text56": "在法律允许的最大范围内，API以“原样”提供和提供，本政策的明文条款代替了双方之间可能产生效力的所有其他条件、担保或其他条款，无论是由法规、普通法还是其他方式含有或纳入的，均在此被排除。",
        "text57": "我们可以将我们在这些条款下的权利和义务转让给任何第三方。",
      }
    }
  },
  "CookiesPolicy": {
    "title": {
      "title": "Cookies政策"
    },
    "body": {
      "title": {
        "title1": "Cookies"
      },
      "text": {
        "text1": "我们使用Cookie使您访问我们的网站变得更有吸引力，并允许使用某些功能。 Cookie是网站保存在计算机上的小型文本文件（永久Cookie），以识别它（可能包含有关您对网站使用的信息）。 Cookie中包含的信息用于存储您做出的个人选择（例如将物品放入购物车中的物品），以便在您离开页面并稍后返回时可以检索它们。 我们还使用Cookie创建非个性化的统计信息。 大多数网络浏览器都会自动接受Cookie。 您可以通过更改浏览器中的设置来防止此情况。 您可以随时通过删除临时互联网文件来删除计算机上存储的Cookie。 数据处理基于您的同意。",
        "text2": "我们使用以下列出的提供商处理与您对我们网站使用的数据相关的数据，以便以最佳方式调整您的兴趣。",
        "text3": "Google Analytics是由Google Inc.（'Google'）提供的网络分析服务。 Google Analytics使用所谓的'Cookie'，这是存储在计算机上的文本文件，允许分析您对网站的使用。 Cookie生成的有关您对网站使用的信息通常会传输到Google在美国的服务器，并在那里存储。 我们使用IP匿名化，因此您的IP地址将首先在Google服务器内被截短，而后在欧洲联盟成员国或签署《欧洲经济区协定》的其他国家内截短。 仅在异常情况下，完整的IP地址将被发送到美国的Google服务器并在那里截短。 Google将代表我们使用此信息评估您对此网站的使用，为我们编制有关网站活动的报告，并为我们提供与网站活动和互联网使用相关的其他服务。 Google Analytics在Google Analytics框架内提供的IP地址将不与任何其他Google数据结合使用。 您可以通过以下链接阻止Cookie存储：",
        "text4": "(http://tools.google.com/dlpage/gaoptout?hl=de) 并下载并安装提供的浏览器插件。",
        "text5": "Google Analytics使用以下cookie：_ga（存储期限为两年），_gid（存储期限为一天），_gat（存储期限为一分钟）。"
      }
    }
  },
  "SignIn": {
    "title": "登录",
    "btn": {
      "btn1": "返回",
      "btn2": "登录",
    },
    "input1": "用户名",
    "input2": "密码",
  },

  "SignUp": {
    "title": "注册",
    "btn": {
      "btn1": "返回",
      "btn2": "注册",
    },
    "input1": "用户名",
    "input2": "密码",
    "input3": "确认密码",
  },

  "Header": {
    "nav1": "首页",
    "nav2": "特性",
    "nav3": "博客",
    "nav4": "联系我们",
    "nav5": "更多",
    "nav6": "隐私政策",
    "nav7": "使用条款",

    "nav8": "登录",
    "nav9": "注册",

    "btn1": "登录",
    "btn2": "注册"
  },

  "footer-title": {
    "title1": "公司",
    "title2": "法律",
    "title3": "支持",
    "title4": "探索",
    "title5": "推荐链接"
  },

  "footer-link": {
    "link1": "关于我们",
    "link2": "招聘",
    "link3": "联系我们",
    "link4": "新闻室",

    "link5": "隐私政策",
    "link6": "使用条款",
    "link7": "Cookie政策",
    "link8": "版权政策",

    "link9": "帮助中心",
    "link10": "客户服务",
    "link11": "常见问题",
    "link12": "报告问题",

    "link13": "特性",
    "link14": "定价",
    "link15": "博客",
    "link16": "常见问题",
    "link17": "Harry Potter House Quiz"
  },
  ...zhLocale


}



// WEBPACK FOOTER //
// ./src/i18n/zh.js